const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const numericPattern = /^-{0,1}\d*\.{0,1}\d+$/;
// ERR_INVALID_PHONENUMBER = 'ERR_INVALID_PHONENUMBER';
// ERR_PHONENUMBER_USED = 'ERR_PHONENUMBER_USED';
// ERR_IMEI_NOT_EXIST = 'ERR_IMEI_NOT_EXIST';
// ERR_IMEI_USED = 'ERR_IMEI_USED';

export default {
  required: value => !!value || 'Không được để trống trường này',
  min: value => value.length >= 6 || 'Vui lòng nhập tối thiểu 6 ký tự',
  numeric: value => {
    return numericPattern.test(value) || 'Vui lòng nhập số';
  },
  numericOrEmpty: value => {
    return value === ''
      ? true
      : numericPattern.test(value) || 'Vui lòng nhập số';
  },
  email: value => {
    return emailPattern.test(value) || 'Email sai định dạng';
  },
};



// WEBPACK FOOTER //
// ./src/utils/validate.js